import { render } from "./photographyDetails.vue?vue&type=template&id=435d8144"
import script from "./photographyDetails.vue?vue&type=script&lang=js"
export * from "./photographyDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__